export default __webpack_public_path__ + "static/media/icon_0.f1f962a2.svg";